import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ContentComponent from './Content';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/pickup" element={<ContentComponent isPickup={true} />} />
        <Route path="/return" element={<ContentComponent isPickup={false} />} />
        <Route path="*" element={<Navigate to="/pickup" />} />
      </Routes>
    </Router>
  );
};

export default App;
